import {Box} from '@mui/material';
import {DataGrid} from '@mui/x-data-grid';
import NoRowsOverlay from './NoRowsOverlay';

// ── Theme-aligned palette (mirrors DocumentsDataGrid) ────────
const ROW_EVEN_BG = '#ffffff';
const ROW_ODD_BG = '#f5f7fa';
const HEADER_BG = '#f5f7fa';
const HEADER_FG = '#455a64';
const HOVER_BG = '#f0f4f8';
const SELECTED_BG = '#e3f2fd';

const PAGE_SIZE_OPTIONS = [5, 10, 25, 50];

const getRowClassName = (params) =>
    params.indexRelativeToCurrentPage % 2 === 0 ? 'row-even' : 'row-odd';

const dataGridSx = {
    border: '1px solid #e0e0e0',
    borderRadius: 2,
    fontSize: '0.875rem',

    '& .MuiDataGrid-columnHeaders': {
        backgroundColor: HEADER_BG,
        color: HEADER_FG,
        fontSize: '0.75rem',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.04em'
    },
    '& .MuiDataGrid-columnHeader': {backgroundColor: HEADER_BG, color: HEADER_FG},
    '& .MuiDataGrid-columnHeaderTitle': {fontWeight: 700, color: HEADER_FG},
    '& .MuiDataGrid-sortIcon': {color: HEADER_FG},
    '& .MuiDataGrid-menuIconButton': {color: HEADER_FG},
    '& .MuiDataGrid-columnSeparator': {color: '#e0e0e0'},
    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {outline: 'none'},
    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {outline: 'none'},

    '& .row-even': {backgroundColor: ROW_EVEN_BG},
    '& .row-odd': {backgroundColor: ROW_ODD_BG},
    '& .row-even:hover': {backgroundColor: HOVER_BG},
    '& .row-odd:hover': {backgroundColor: HOVER_BG},
    '& .row-even.Mui-selected': {backgroundColor: SELECTED_BG},
    '& .row-odd.Mui-selected': {backgroundColor: SELECTED_BG},

    '& .MuiDataGrid-cell': {borderBottom: '1px solid #e4ecf2', alignItems: 'center', display: 'flex'},
    '& .MuiDataGrid-footerContainer': {borderTop: '2px solid #e0e0e0', backgroundColor: HEADER_BG},
    '& .MuiDataGrid-virtualScroller': {minHeight: 200},
};

export default function SubmissionsDataGrid({
                                                rows,
                                                columns,
                                                loading,
                                                rowCount,
                                                paginationModel,
                                                onPaginationModelChange,
                                            }) {
    return (
        <Box sx={{width: '100%', overflowX: 'auto'}}>
            <DataGrid
                rows={rows}
                columns={columns}
                loading={loading}
                rowCount={rowCount}
                paginationMode="server"
                paginationModel={paginationModel}
                onPaginationModelChange={onPaginationModelChange}
                pageSizeOptions={PAGE_SIZE_OPTIONS}
                disableRowSelectionOnClick
                disableColumnMenu
                getRowClassName={getRowClassName}
                getRowId={(row) => row.id}
                rowHeight={60}
                autoHeight
                sx={dataGridSx}
                slots={{ noRowsOverlay: NoRowsOverlay }}
            />
        </Box>
    );
}
